import React from 'react';

interface BSkeletonCardProps {
    width: string;
    height: string;
}

const BSkeletonCard: React.FC<BSkeletonCardProps> = ({width, height}) => {
    return (
        <div className="container">
            <div className="row">
                <div className="col-12 col-md-4">
                    <div className="skeleton-left">
                        <div className="square circle"></div>
                    </div>
                </div>
                <div className="col-12 col-md-8">
                    <div className="skeleton-right">
                        <div className="line h17 w40 m10"></div>
                        <div className="line"></div>
                        <div className="line h8 w50"></div>
                        <div className="line w75"></div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default BSkeletonCard;
